import React from 'react';

function AreaCard({ title, phones, email, address, links }) {
  return (
    <div className="border-l-4 border-green-500 bg-white p-4 shadow-carritoshadow flex flex-col items-start text-left h-full rounded-xl">
      {/* Título siempre en la parte superior */}
      <h3 className="font-bold text-xl mb-4">{title}</h3>
      
      {/* Contenido centrado verticalmente */}
      <div className="flex-grow flex flex-col justify-center">
        {phones && (
          <div className="mb-4">
            <strong>Teléfonos:</strong>
            <ul className="list-disc pl-5">
              {phones.map((phone, index) => (
                <li key={index}>
                  {phone.number} <strong>({phone.name})</strong>
                </li>
              ))}
            </ul>
          </div>
        )}
        {email && <p className="mb-4"><strong>Email:</strong> {email}</p>}
        {address && <p className="mb-4"><strong>Dirección:</strong> {address}</p>}
        {links && (
          <div className="mb-4">
            {links.map((link, index) => (
              <div key={index} className="mb-2">
                {/* Margen inferior para separar cada enlace */}
                <strong>{link.name}:</strong>{" "}
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`font-bold ${link.color}`}
                >
                  {link.text}
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AreaCard;
